import React from 'react';
import { scroller } from 'react-scroll';
import './ScrollIndicator.css';

const SECTIONS = [
  { name: 'hero', label: 'Home' },
  { name: 'about', label: 'About' },
  { name: 'projects', label: 'Projects' },
  { name: 'blog', label: 'Blog' },
  { name: 'contact', label: 'Contact' },
];

function ScrollIndicator({ activeSection }) {
  const handleClick = (name) => {
    scroller.scrollTo(name, {
      smooth: true,
      duration: 600,
      offset: -48,
      ease: 'easeInOutQuad',
    });
  };

  return (
    <div className="scroll-indicator">
      {SECTIONS.map((section) => (
        <button
          key={section.name}
          className={`scroll-indicator-line ${activeSection === section.name ? 'active' : ''}`}
          onClick={() => handleClick(section.name)}
          aria-label={`Go to ${section.label}`}
          title={section.label}
        />
      ))}
    </div>
  );
}

export default ScrollIndicator;
